module.exports = __webpack_public_path__ + "media/KZ-KZY.b032607a.ogg";